<template>
  <div
    class="tfinderlayout"
    >
    <div
      v-if="sidebar_left"
      class="tfinderlayout-sidebar-right"
      :style="`width: ${$vuetify.breakpoint.smAndUp ? '240px' : '50px'};`"
    >
      <div class="tfinderlayout-sidebar-right-header">
        <slot name="sidebar-left-header"/>
      </div>
      <div class="tfinderlayout-sidebar-right-body">
        <slot name="sidebar-left-body"/>
      </div>
      <div class="tfinderlayout-sidebar-right-footer">
        <slot name="sidebar-left-footer"/>
      </div>
    </div>
    <div
      v-else
      :class="`tfinderlayout-sidebar`"
      :style="`width: ${$vuetify.breakpoint.smAndUp ? '240px' : '50px'};`"
    >
      <slot name="sidebar"/>
      <template v-if="connect">
      <div class="tfinderlayout-side-bar-community">
        <slot name="sidebar-community"/>
      </div>
      <v-divider class="color-white-09 mb-2 mt-2"/>
      <div class="tfinderlayout-side-bar-company">
        <slot name="sidebar-company"/>
      </div>
      </template>
    </div>
    <div
      class="tfinderlayout-main"
      :style="sidebar_right?'width: calc(100% - 480px)':''"
    >
      <div
        v-if="!no_action_bar"
        class="tfinderlayout-action-bar">
        <slot name="actionbar"/>
      </div>
      <div
        class="tfinderlayout-content"
        :style="no_action_bar?'height: 100%':''"
      >
        <slot name="content"/>
      </div>
    </div>
    <div
      v-if="sidebar_right"
      class="tfinderlayout-sidebar-right"
    >
      <div class="tfinderlayout-sidebar-right-header">
        <slot name="sidebar-right-header"/>
      </div>
      <div class="tfinderlayout-sidebar-right-body">
        <slot name="sidebar-right-body"/>
      </div>
      <div class="tfinderlayout-sidebar-right-footer">
        <slot name="sidebar-right-footer"/>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['connect', 'no_action_bar', 'sidebar_right', 'sidebar_left'],
    data: () => ({
    }),
  }
</script>
<style>
  .tfinderlayout {
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    padding: 2px;
  }
  .tfinderlayout-sidebar {
    display: flex;
    flex-direction: column;
    width: 240px;
    padding: 12px;
    box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.4);
    z-index: 1;
    background-color: var(--v-color-2-5-base);
  }
  .tfinderlayout-sidebar-right {
    display: flex;
    flex-direction: column;
    width: 240px;
    padding: 12px;
    box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.4);
    z-index: 1;
    background-color: rgb(41,41,41);
  }
  .tfinderlayout-sidebar-right-header {
    color: rgba(255,255,255, 0.4);
  }
  .tfinderlayout-sidebar-right-body {
    position: relative;
    height: calc(100% - 45px);
    border-bottom: solid 1px var(--v-color-7-base);
    overflow: auto;
    padding-bottom: 30px;
  }
  .tfinderlayout-sidebar-right-footer {
    display: flex;
    height: 45px;
    align-items: center;
  }
  .tfinderlayout-main {
    display: flex;
    flex-direction: column;
    width: calc(100% - 240px);
    height: 100%;
    background-color: var(--v-color-7-base);
  }
  .tfinderlayout-action-bar {
    display: flex;
    width: 100%;
    height: 45px;
    align-items: center;
    border-bottom: solid 1px var(--v-color-2-5-base);
    margin-bottom: 6px;
    padding: 3px;
  }
  .tfinderlayout-content {
    position: relative;
    display: flex;
    width: 100%;
    height: calc(100% - 51px);
    overflow: auto;
  }
  .tfinderlayout-side-bar-community {
    height: 50%;
    width: 100%;
  }
  .tfinderlayout-side-bar-company {
    height: 50%;
    width: 100%;
  }

  @media only screen and (max-width: 959px) {
    /* .tfinderlayout-sidebar {
      display: flex;
      flex-direction: column;
      width: 50px;
      padding: 12px;
      box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.4);
      z-index: 1;
      background-color: rgb(41,41,41);
    } */
    /* .tfinderlayout-sidebar-right {
      display: flex;
      flex-direction: column;
      width: 50px;
      padding: 12px;
      box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.4);
      z-index: 1;
      background-color: rgb(41,41,41);
    } */
    .tfinderlayout-main {
      display: flex;
      flex-direction: column;
      width: calc(100% - 50px);
      height: 100%;
      background-color: rgb(30,30,30);
    }
  }


</style>
